export default __webpack_public_path__ + "static/media/parking.614bef6a.svg";